export type CreditStatus = 'healthy' | 'low' | 'critical';

const STATUS_COLORS: Record<CreditStatus, { progress: string; ring: string }> = {
    critical: { progress: 'red.6', ring: 'red' },
    low: { progress: 'orange.6', ring: 'orange' },
    healthy: { progress: 'teal.5', ring: 'teal' },
};

export const getCreditStatus = (ratio: number): CreditStatus => {
    if (ratio <= 0.1) return 'critical';
    if (ratio <= 0.25) return 'low';
    return 'healthy';
};

export const getCreditProgressColor = (status: CreditStatus) => STATUS_COLORS[status].progress;

export const getCreditRingColor = (status: CreditStatus) => STATUS_COLORS[status].ring;
